import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "file-arae" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("NEW+ ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Create A New Green Learning.", -1)
const _hoisted_4 = { style: {"margin-left":"10px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"width":"120px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Id ")
const _hoisted_8 = { style: {"width":"300px"} }
const _hoisted_9 = { style: {"width":"120px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Dao Id ")
const _hoisted_11 = { style: {"width":"300px"} }
const _hoisted_12 = { style: {"width":"120px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Dao Name ")
const _hoisted_14 = { style: {"width":"300px"} }
const _hoisted_15 = { style: {"width":"120px"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Title ")
const _hoisted_17 = { style: {"width":"300px"} }
const _hoisted_18 = { style: {"width":"120px"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Description ")
const _hoisted_20 = { style: {"width":"300px"} }
const _hoisted_21 = { style: {"width":"120px"} }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Type ")
const _hoisted_23 = { style: {"width":"300px"} }
const _hoisted_24 = { style: {"width":"120px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("URL ")
const _hoisted_26 = { style: {"width":"300px"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"120px"} }, null, -1)
const _hoisted_28 = { style: {"width":"300px"} }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Select Files")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("cancel")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("confirm")
const _hoisted_33 = { class: "card-header" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Id: ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Owner: ")
const _hoisted_36 = ["src"]
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Prev ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Next ")

import { getCurrentInstance, ComponentInternalInstance, ref } from 'vue'

import { toRaw } from '@vue/reactivity'
import { genFileId } from 'element-plus'
import * as path from "path"
import type { UploadInstance, UploadProps, UploadRawFile, UploadFile, UploadFiles } from 'element-plus'

import { connected, connectState } from "../libs/connect"
import * as constant from "../constant"
import * as element from "../libs/element"
import * as tools from "../libs/tools"
import * as storage from '../libs/storage'
import { GreenDao } from "../libs/greendao"
import { GreenLearning } from "../libs/greenlearning"
 

const __default__ = {
  name: 'LearningsPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  
const { proxy } = getCurrentInstance() as ComponentInternalInstance;

const activeName = connectState.activeName;
const loadStatus = ref(false);
const loadResourceStatus = ref(false);

const greendao = new GreenDao();
const greenlearning = new GreenLearning();

const multiple = ref(false);
const limits = ref(1);
const resourceAccept = ref('');
const uploadResource = ref<UploadInstance>();
const resourceFileList = ref(new Array());

const showAddNewLearningVisiable = ref(false);
const loadDrawerStatus = ref(false);
const daoId = ref(0);
const daoName = ref('');
const learningId = ref(0);
const learningTitle = ref('');
const learningDescription = ref('');
const learningResource = ref('');
const learningResourceType = ref('image');

const greenLearningList = ref(new Array());
const hasMore = ref(false);
const pageSize = ref(6);
const pageCount = ref(0);

const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;

//address explore url
const tokenExplorerUrl = (address:string, tokenId:string = '') => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      if(tokenId != ''){
        return `${blockExplorerUrls}/token/${address}?a=${tokenId}#inventory`
      }
      return `${blockExplorerUrls}/token/${address}`
    }
  }
  return address;
}

//address explore url
const addressExplorerUrl = (address:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return `${blockExplorerUrls}/address/${address}`
    }
  }
  return address;
}

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }
  return transaction;
}

//on click to copy address
const onClickToCopy = async (content:string) => {
  tools.clickToCopy(content);
  
  element.elMessage('success', 'Copy ' + content + ' to clipboard success.');     
};

//get dao id
const getDaoId = () => {
  const daoId = tools.getUrlParamter('daoId');
  try{
    return Number(daoId);
  }catch(e){
    return 0;
  }
}

//update dao name by dao id
const updateDaoName = async (daoId:Number) => {
  const daoInfo = await greendao.getDaoInfoById(daoId);
  daoName.value = daoInfo.daoName;
}

//on learning type change
const onLearningResourceTypeChange = async () => {
  learningResource.value = '';
  uploadResource.value!.clearFiles();

  const currentClass = (proxy as any).$el.parentNode.querySelector(".upload-resource");

  if(learningResourceType.value === 'image'){
    resourceAccept.value = 'image/*';
    limits.value = 1;
    multiple.value = false;
    (currentClass.querySelector(".el-upload__input") as any).webkitdirectory = false;  
  }else if(learningResourceType.value === 'audio'){
    resourceAccept.value = 'audio/*';
    limits.value = 1;
    multiple.value = false;
    (currentClass.querySelector(".el-upload__input") as any).webkitdirectory = false;  
  }else if(learningResourceType.value === 'video'){
    resourceAccept.value = 'video/*';
    limits.value = 1;
    multiple.value = false;
    (currentClass.querySelector(".el-upload__input") as any).webkitdirectory = false;  
  }else {
    resourceAccept.value = '';
    limits.value = 0;
    multiple.value = true;
    (currentClass.querySelector(".el-upload__input") as any).webkitdirectory = true;
  }
}

//on learning resource files change
const onChangeSelectResourceFiles = async (uploadFile: UploadFile, uploadFiles: UploadFiles) => {
  resourceFileList.value = toRaw(uploadFiles);

  if(multiple.value){
    learningResource.value = (resourceFileList.value[0].raw as any).webkitRelativePath.split(path.sep)[0];
    if(learningResource.value === ''){
      learningResource.value = (resourceFileList.value[0].raw as any).name;
    }
  }else{
    learningResource.value = (resourceFileList.value[0].raw as any).name;
  }
}

//on click to select learning resource files
const onSelectResourceFiles = async () => {
  uploadResource.value!.clearFiles();
}

//handle file exceed
const handleResourceExceed: UploadProps['onExceed'] = (files:any) => {
  if(multiple.value === false){
    uploadResource.value!.clearFiles();
    const file = files[0] as UploadRawFile;
    file.uid = genFileId();
    uploadResource.value!.handleStart(file);
  }
};

//on click to upload learning resource files
const onUploadResourceFiles = async () => {
  if(multiple.value){
    await opUploadResourceFolder();
  }else{
    await opUploadResourceFile();
  }
}

//upload a sigle file
const opUploadResourceFile = async () => {
  try{

      loadResourceStatus.value = true;

      if(toRaw(resourceFileList.value).length === 0){
        element.elMessage('warning', 'You have not select any file to upload!');
        return;
      }

      learningResource.value = await storage.uploadFile(toRaw(resourceFileList.value)[0]);
    }catch(e){
      element.alertMessage(e);
    }finally{
      loadResourceStatus.value = false;
    }
}

//upload a website folder, must has an index.html in the root path of the folder
const opUploadResourceFolder = async () => {
    try{

      loadResourceStatus.value = true;

      if(toRaw(resourceFileList.value).length === 0){
        element.elMessage('warning', 'You have not select any folder to upload!');
        return;
      }

      let directory = (resourceFileList.value[0].raw as any).webkitRelativePath.split(path.sep)[0];
      if(directory === ''){
        directory = (resourceFileList.value[0].raw as any).name;
      }

      let findIndex = false;

      for(const i in resourceFileList.value){
        const file = resourceFileList.value[i];
        if((file.raw as any).name === 'index.html'){
          findIndex = true;
          break;
        }
      }

      if(findIndex === false){
        element.elMessage('warning', 'Not a valid website folder, index.html not found in the root path!');
        return;
      }

      learningResource.value = await storage.uploadFolder(directory, toRaw(resourceFileList.value));
    }catch(e){
      element.alertMessage(e);
    }finally{
      loadResourceStatus.value = false;
    }
}

//on click to create a new learning 
const onAddNewLearningOpen = async () => {
  daoId.value = getDaoId();
  learningId.value = 0;
  learningTitle.value = '';
  learningDescription.value = '';
  learningResource.value = '';
  learningResourceType.value = 'image';

  await onLearningResourceTypeChange();

  await updateDaoName(daoId.value);
}

//cancle create the learning
const cancelLearningUpdate = async () => {
  showAddNewLearningVisiable.value = false;
}

//confirm to create the new learning
const confirmLearningUpdate = async () => {
  try{
    loadDrawerStatus.value = true;

    //learning type baseod the resources
    let learningType;
    if (learningResourceType.value === 'image'){
      learningType = 0;
    }else if(learningResourceType.value === 'audio'){
      learningType = 1;
    }else if(learningResourceType.value === 'video'){
      learningType = 2;
    }else {
      learningType = 3;
    }

    const tx = await greenlearning.mint(learningTitle.value, learningDescription.value, learningResource.value, daoId.value, learningType);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Create new learning success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    showAddNewLearningVisiable.value = false;

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }
}

//click to delete a green learning
const onDeleteGreenLearning = async (learningId:number) => {
  try{
    const tx = await greenlearning.burn(learningId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Delete learning success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }
}

//click to like a green learning
const onLikeLearning = async (learningId:number) => {
  try{
    const tx = await greenlearning.likeTheLearning(learningId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Like the learning success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }  
}

//click to hate a green learning
const onHateLearning = async (learningId:number) => {
  try{
    const tx = await greenlearning.hateTheLearning(learningId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Hate the learning success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }  
}

//get green learning infos by page size and page count
const getGreenLearningCount = async (onlyOwner:boolean) => {
  daoId.value = getDaoId();

  const indexs = await greenlearning.getLearningIndexsByPageCount(pageSize.value, pageCount.value, daoId.value, onlyOwner);

  if(indexs.length < pageSize.value){
    hasMore.value = false;
  }else{
    hasMore.value = true;
  }

  const infoList = new Array();
  for(const i in indexs){
    const res = await greenlearning.getLearningInfoById(indexs[i]);

    //if dao not exists, skip
    try{
      const daoInfo = await greendao.getDaoInfoById(res.daoId);
      res.daoName = daoInfo.daoName;
      res.daoAvatar = daoInfo.daoAvatar;
      res.daoWebsite = daoInfo.daoWebsite;
      res.daoDesc = daoInfo.daoDesc;
      res.daoOwner = daoInfo.daoOwner;
      res.daoPublic = daoInfo.daoPublic;
      res.daoMembers = daoInfo.daoMembers;
    }catch(e){
      continue;
    }

    infoList.push(res);
  }

  greenLearningList.value = infoList;
}

//on click for prev page
const onHandlePrev = async () => {
  if(pageCount.value > 0){
    pageCount.value--;
  }
  handleClick();
}

//on click for next page
const onHandleNext = async () => {
  if(hasMore.value){
    pageCount.value++;
  }
  handleClick();
}

//handle page refresh
const handleClick = async () => {
  //wait for the active name change
  await tools.sleep(100);

  connectState.activeName.value = activeName.value;
  tools.setUrlParamter('activeName', activeName.value);

  try{
    loadStatus.value = true;
    if (!(await connected())){
      greenLearningList.value = new Array();
      return;
    }

    if(pageCount.value < 0){
      pageCount.value = 0;
    }

    const onlyOwner = activeName.value === 'mine';

    await getGreenLearningCount(onlyOwner);

  }catch(e){
    greenLearningList.value = new Array();
  }finally{
    loadStatus.value = false;
  }
}

//clean search content and bind search callback function
connectState.search = '';
connectState.searchCallback = handleClick;
//try get activeName from the url paramter
try{
  activeName.value = tools.getUrlParamter('activeName');
  if(activeName.value != 'all' && 
    activeName.value != 'mine'){
    activeName.value = 'all';
  }
}catch(e){
  activeName.value = 'all';
}
//update page size
handleClick();

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"background-color":"#ffffff"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: _unref(activeName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : null)),
              class: "file-tabs",
              onTabClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "All",
                  name: "all"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Mine",
                  name: "mine"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              style: {"float":"right","margin-right":"50px"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => {showAddNewLearningVisiable.value = true;})
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_drawer, {
              modelValue: showAddNewLearningVisiable.value,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((showAddNewLearningVisiable).value = $event)),
              direction: "rtl",
              "destroy-on-close": "",
              onOpened: onAddNewLearningOpen
            }, {
              header: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_4, [
                  (learningId.value > 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                        _createElementVNode("td", _hoisted_6, [
                          _hoisted_7,
                          _createVNode(_component_el_popover, {
                            placement: "top-start",
                            title: "Learning Id",
                            width: 200,
                            trigger: "hover",
                            content: "The id of the green learning."
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_QuestionFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("td", _hoisted_8, [
                          _createVNode(_component_el_input, {
                            modelValue: learningId.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((learningId).value = $event)),
                            disabled: ""
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_el_icon, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (onClickToCopy(learningId.value)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_document_copy)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Id",
                        width: 200,
                        trigger: "hover",
                        content: "The dao id of the green dao. The learning must be published through the dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_component_el_input, {
                        modelValue: daoId.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((daoId).value = $event)),
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (updateDaoName(daoId.value))),
                        disabled: learningId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (onClickToCopy(daoId.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Name",
                        width: 200,
                        trigger: "hover",
                        content: "The name of the green dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createVNode(_component_el_input, {
                        modelValue: daoName.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((daoName).value = $event)),
                        disabled: ""
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (onClickToCopy(daoName.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Learning Title",
                        width: 200,
                        trigger: "hover",
                        content: "The title of the green learning."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createVNode(_component_el_input, {
                        modelValue: learningTitle.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((learningTitle).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (onClickToCopy(learningTitle.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Learning Description",
                        width: 200,
                        trigger: "hover",
                        content: "The description of the green learning."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createVNode(_component_el_input, {
                        modelValue: learningDescription.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((learningDescription).value = $event)),
                        type: "textarea",
                        rows: "5"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Learning Resource Type",
                        width: 200,
                        trigger: "hover",
                        content: "The resource type of the green learning."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      _createVNode(_component_el_select, {
                        modelValue: learningResourceType.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((learningResourceType).value = $event)),
                        style: {"width":"100%","margin-left":"0px"},
                        placeholder: "Select Resource Type",
                        teleported: false,
                        onChange: onLearningResourceTypeChange,
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            key: "image",
                            label: "Image",
                            value: "image"
                          }),
                          _createVNode(_component_el_option, {
                            key: "audio",
                            label: "Audio",
                            value: "audio"
                          }),
                          _createVNode(_component_el_option, {
                            key: "video",
                            label: "Video",
                            value: "video"
                          }),
                          _createVNode(_component_el_option, {
                            key: "website",
                            label: "Website",
                            value: "website"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Learning Resource",
                        width: 200,
                        trigger: "hover",
                        content: "The resource url link of the green learning. You can input the url link directly or upload the resource files through the upload button."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createVNode(_component_el_input, {
                        modelValue: learningResource.value,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((learningResource).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (onClickToCopy(learningResource.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("tr", {
                    "element-loading-text": "Uploading...",
                    "element-loading-spinner": svg,
                    "element-loading-svg-view-box": "-10, -10, 50, 50",
                    "element-loading-background": "#ffffff"
                  }, [
                    _hoisted_27,
                    _createElementVNode("td", _hoisted_28, [
                      _createVNode(_component_el_upload, {
                        style: {"width":"100px","height":"0px","float":"right","margin-right":"100px"},
                        drag: false,
                        multiple: multiple.value,
                        class: "upload-resource",
                        ref_key: "uploadResource",
                        ref: uploadResource,
                        action: "",
                        onChange: onChangeSelectResourceFiles,
                        onClick: onSelectResourceFiles,
                        accept: resourceAccept.value,
                        limit: limits.value,
                        "on-exceed": handleResourceExceed,
                        "show-file-list": false,
                        "auto-upload": false
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            style: {"float":"right","margin-right":"10px","width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["multiple", "accept", "limit"]),
                      _createVNode(_component_el_button, {
                        type: "success",
                        style: {"float":"right"},
                        onClick: onUploadResourceFiles
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      })
                    ])
                  ])), [
                    [_directive_loading, loadResourceStatus.value]
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"flex":"auto"},
                  "element-loading-text": "Submitting...",
                  "element-loading-spinner": svg,
                  "element-loading-svg-view-box": "-10, -10, 50, 50",
                  "element-loading-background": "#ffffff"
                }, [
                  _createVNode(_component_el_button, { onClick: cancelLearningUpdate }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: confirmLearningUpdate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_loading, loadDrawerStatus.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, {
          style: {"height":"450px","margin-top":"20px"},
          "element-loading-text": "Loading...",
          "element-loading-spinner": svg,
          "element-loading-svg-view-box": "-10, -10, 50, 50",
          "element-loading-background": "#ffffff"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(greenLearningList.value, (info) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    key: info.learningId,
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "box-card" }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_el_popover, {
                              placement: "bottom-start",
                              width: 230,
                              title: "Dao Info"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_link, {
                                  type: "success",
                                  target: "_blank",
                                  href: info.daoWebsite
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_avatar, {
                                      src: info.daoAvatar,
                                      size: "small"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 2
                                }, 1032, ["href"])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("h4", null, "Name: " + _toDisplayString(info.daoName), 1),
                                _createElementVNode("h4", null, [
                                  _hoisted_34,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(_unref(greendao).getAddress(),info.daoId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.daoId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, [
                                  _hoisted_35,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: addressExplorerUrl(info.daoOwner)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.daoOwner), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, "Members: " + _toDisplayString(info.daoMembers), 1),
                                _createElementVNode("h4", null, "Public: " + _toDisplayString(info.daoPublic), 1),
                                _createElementVNode("h4", null, "Description: " + _toDisplayString(info.daoDesc), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_popover, {
                              placement: "bottom-start",
                              width: 230,
                              title: "Learning Info"
                            }, {
                              reference: _withCtx(() => [
                                _createElementVNode("span", null, [
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(_unref(greenlearning).getAddress(),info.learningId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.learningName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("h4", null, "Title: " + _toDisplayString(info.learningName), 1),
                                _createElementVNode("h4", null, "Description: " + _toDisplayString(info.learningDesc), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("span", null, [
                              (_unref(activeName) === 'mine')
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "danger",
                                    style: {"float":"right"},
                                    size: "small",
                                    onClick: ($event: any) => (onDeleteGreenLearning(info.learningId))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              (info.learningType === 0)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: info.learningUrl,
                                    style: {"width":"250px","height":"200px"}
                                  }, null, 8, _hoisted_36))
                                : _createCommentVNode("", true),
                              (info.learningType === 1)
                                ? (_openBlock(), _createElementBlock("audio", {
                                    key: 1,
                                    src: info.learningUrl,
                                    controls: "",
                                    preload: "",
                                    style: {"width":"250px","height":"200px"}
                                  }, null, 8, _hoisted_37))
                                : _createCommentVNode("", true),
                              (info.learningType === 2)
                                ? (_openBlock(), _createElementBlock("video", {
                                    key: 2,
                                    src: info.learningUrl,
                                    controls: "",
                                    preload: "",
                                    style: {"width":"250px","height":"200px"}
                                  }, null, 8, _hoisted_38))
                                : _createCommentVNode("", true),
                              (info.learningType === 3)
                                ? (_openBlock(), _createElementBlock("iframe", {
                                    key: 3,
                                    frameborder: "0",
                                    sandbox: "allow-scripts allow-same-origin allow-popups",
                                    src: info.learningUrl,
                                    style: {"width":"250px","height":"200px"}
                                  }, null, 8, _hoisted_39))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { style: {"margin-top":"5px","float":"right"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_link, {
                                type: "primary",
                                style: {"float":"right"},
                                onClick: ($event: any) => (onLikeLearning(info.learningId))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Likes : " + _toDisplayString(info.learningLikes), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_link, {
                                type: "warning",
                                style: {"float":"right"},
                                onClick: ($event: any) => (onHateLearning(info.learningId))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Hates : " + _toDisplayString(info.learningHates), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_link, {
                                type: "success",
                                style: {"float":"right"},
                                size: "small",
                                href: info.learningUrl,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_40
                                ]),
                                _: 2
                              }, 1032, ["href"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, loadStatus.value]
        ]),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandlePrev
              }, {
                default: _withCtx(() => [
                  _hoisted_41
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandleNext,
                disabled: !hasMore.value
              }, {
                default: _withCtx(() => [
                  _hoisted_42
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})